import styled from "styled-components";

const Row = styled.div`
    @media (max-width: 575px) {
        // padding: 0 40px;
    }
`;
export default Row;
